import type { BreakdownBudgetAnalytic } from '../types'

export const MOCK_BUDGETS_ANALYTICS: BreakdownBudgetAnalytic = {
  'atlas/legacy': [
    {
      actuals: {
        unit: 'DAI',
        value: 0,
      },
      budget: {
        unit: 'DAI',
        value: 0,
      },
      forecast: {
        unit: 'DAI',
        value: 0,
      },
      paymentsOffChainIncluded: {
        unit: 'DAI',
        value: 0,
      },
      paymentsOnChain: {
        unit: 'DAI',
        value: 0,
      },
      protocolNetOutflow: {
        unit: 'DAI',
        value: 0,
      },
    },
  ],
  'atlas/immutable': [
    {
      actuals: {
        unit: 'DAI',
        value: 0,
      },
      budget: {
        unit: 'DAI',
        value: 0,
      },
      forecast: {
        unit: 'DAI',
        value: 0,
      },
      paymentsOffChainIncluded: {
        unit: 'DAI',
        value: 0,
      },
      paymentsOnChain: {
        unit: 'DAI',
        value: 0,
      },
      protocolNetOutflow: {
        unit: 'DAI',
        value: 0,
      },
    },
  ],
  'atlas/scopes': [
    {
      actuals: {
        unit: 'DAI',
        value: 0,
      },
      budget: {
        unit: 'DAI',
        value: 1642500.0000000005,
      },
      forecast: {
        unit: 'DAI',
        value: 1166666.68,
      },
      paymentsOffChainIncluded: {
        unit: 'DAI',
        value: 0,
      },
      paymentsOnChain: {
        unit: 'DAI',
        value: 0,
      },
      protocolNetOutflow: {
        unit: 'DAI',
        value: 0,
      },
    },
  ],
}
